export default __webpack_public_path__ + "static/media/Devil.b9a2f774.webm";